export class I18n {
  constructor(baseScope = '', translations) {
    this.baseScope = baseScope;
    this.translations = translations
  }

  t(key, params = {}) {
    if (key.startsWith('.')) {
      const fullKey = this.baseScope + key;
      const value = this.lookup(fullKey);
      
      return Array.isArray(value) ? 
        value.map(text => this.tParams(text, params)) : 
        (typeof value === 'string' ? this.tParams(value, params) : fullKey);
    }
  
    return this.lookup(key, params);
  }

  lookup(key, params = {}) {
    const parts = key.split('.');
    const value = parts.reduce((acc, part) => {
      if (!acc) return undefined;
      return acc[part];
    }, this.translations);

    return typeof value === 'string' ? this.tParams(value, params) : value;
  }

  setContext(additionalScope) {
    const newScope = this.baseScope ? `${this.baseScope}.${additionalScope}` : additionalScope;
    return new I18n(newScope, this.translations);
  }

  tParams(string, params) {
    let newString = string;
    let keys = params instanceof Object ? Object.keys(params) : [];
  
    if(keys.length === 0) return string;
  
    keys.forEach((key) => {
      const escapedKey = key.replace(/[.*+?^${}()|[]\\]/g, '\\$&');
      let reg = `%{(${escapedKey})}*`;
      let regex = new RegExp(reg);
  
      newString = newString.replace(regex, ()=> params[key]);
    });
  
    return newString
  }
}
